var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCaretRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right",
    clipPath: "url(#clip0_1050_30805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2195 5.66306L4.18205 0.947433C4.16627 0.935013 4.14731 0.927294 4.12735 0.925163C4.10738 0.923033 4.08722 0.926576 4.06918 0.935388C4.05113 0.944199 4.03594 0.95792 4.02535 0.974976C4.01475 0.992031 4.00918 1.01173 4.00928 1.03181V2.06708C4.00928 2.1327 4.04008 2.19565 4.09098 2.23583L8.9124 6.00056L4.09098 9.76529C4.03874 9.80547 4.00928 9.86842 4.00928 9.93404V10.9693C4.00928 11.059 4.1124 11.1086 4.18205 11.0537L10.2195 6.33806C10.2709 6.29803 10.3124 6.24683 10.3409 6.18834C10.3695 6.12986 10.3843 6.06564 10.3843 6.00056C10.3843 5.93548 10.3695 5.87125 10.3409 5.81277C10.3124 5.75429 10.2709 5.70309 10.2195 5.66306Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1050_30805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.821777 0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaretRight);
export default __webpack_public_path__ + "static/media/icon-caret-right.113c7b42a0c400b14b3d6cc51c68d463.svg";
export { ForwardRef as ReactComponent };